"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageBlock = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Types_1 = require("@/Types");
exports.ImageBlock = styled_components_1.default.div `
  ${props => props.variantType === Types_1.VariantTypes.FULL_VIEW &&
    `padding: ${props.theme.spacing.s4}px ${props.theme.spacing.s2}px;
  height: ${props.theme.constants.blockHeight.s9}px;
  width: ${props.theme.constants.blockHeight.s9}px;
  border: 1px solid ${props.theme.palette.BLUE_GRAY_20};
  margin-right: ${props.theme.spacing.m3}px;
  flex-shrink: 0;
  `}

  ${props => props.variantType === Types_1.VariantTypes.MINI_CART_VIEW &&
    `height: ${props.theme.spacing.xl1}px; width: ${props.theme.spacing.xl1}px; margin-right: ${props.theme.spacing.s4}px; img { width: 100%; }`}
    ${props => props.variantType === Types_1.VariantTypes.CAROUSEL_VIEW &&
    `height: ${props.theme.constants.blockHeight.s10}px; width: ${props.theme.constants.blockHeight.s10}px; margin-bottom: ${props.theme.spacing.s4}px; img { width: 100%; }`}
    ${props => props.variantType === Types_1.VariantTypes.SEARCH_VIEW &&
    `align-self: center;height: 100%; max-height: ${props.theme.constants.blockHeight.s10}px; width:100%; max-width: ${props.theme.constants.blockHeight.s10}px; margin-bottom: ${props.theme.spacing.s4}px; img { width: 100%; }`}


  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    ${props => props.variantType === Types_1.VariantTypes.FULL_VIEW &&
    `
      margin: 0;
    `}
  }
`;
exports.default = {
    ImageBlock: exports.ImageBlock
};
